/**
 * Base query parameters to filter.
 * The utm and odin params are used to signal that the API gateway
 * should check the current referer against the previous referer
 * and generate an arrival if they are different.
 * Remove utm and odin params from query string when navigating
 * so that a new arrival is not created every time.
 */
export const BASE_FILTER_PARAMS = [
  /^utm_(.*)/g,
  /^odin+$/g,
];

export const SSO_FILTER_PARAMS = [
  /^xid+$/g,
  /^asid+$/g,
  /^_e+$/g,
  /^rt+$/g,
  /^oi+$/g,
  /^creative+$/g,
  /^creativeid+$/g,
  /^subid+$/g,
  /^gclid+$/g,
  /^content+$/g,
  /^_esk+$/g,
  /^_ssk+$/g,
];

export const FOR_YOU_FILTER_PARAMS = [];
